import React, { useContext, SyntheticEvent } from "react";
import { useTranslation } from "react-i18next";

//MUI
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";

//Custom Components
import DraggableDialog from "@/ui/Dialog/DraggableDialog";
import DialogHeader from "@/ui/Dialog/DialogHeader";
import DialogToolbarHeading from "@/ui/Dialog/DialogToolbarHeading";
import DialogToolbarButtonClose from "@/ui/Dialog/ToolbarButtons/DialogToolbarButtonClose";
import ToolbarFillContent from "@/ui/Toolbar/ToolbarFillContent";
import DialogBody from "@/ui/Dialog/DialogBody";

import DialogContext from "@/ui/DialogContext/DialogContext";
import { IDialogProps } from "@/@types/ui/DialogContext";
import { Typography } from "@mui/material";
import { Check } from "@mui/icons-material";

function ThankYouDialog(props: IDialogProps) {
  const { onClose } = props;

  const { t } = useTranslation();
  const dialogContext = useContext(DialogContext);

  const close = (result: any) => {
    if (onClose) {
      onClose(result);
    }

    dialogContext.hideDialog();
  };

  const handleClose = (evt: SyntheticEvent) => {
    close({ success: false });
  }

  return (
    <DraggableDialog open={true} maxWidth={"sm"} onClose={handleClose}>
      <DialogHeader>
        <Toolbar variant="dense" disableGutters={true}>
          <Check sx={{ transform: "scale(1.3)" }} />
          <DialogToolbarHeading>{t("messages.comment_success")}</DialogToolbarHeading>
          <ToolbarFillContent />
          <DialogToolbarButtonClose onClick={handleClose} />
        </Toolbar>
      </DialogHeader>
      <DialogBody>
        <Box m={2} display="flex" flexDirection="column" textAlign={"center"}>
          <Typography variant="h3">{t("messages.comment_thank_you")}</Typography>
          <Typography variant="body2">{t("messages.comment_thank_you_sub")}</Typography>
        </Box>
      </DialogBody>
    </DraggableDialog>
  )
}

export default ThankYouDialog
